import { j as e } from "../../../../node_modules/react/jsx-runtime.js";
import m from "react";
import { useSensors as f, useSensor as a, DndContext as p, KeyboardSensor as S, PointerSensor as b } from "../../../../node_modules/@dnd-kit/core/dist/core.esm.js";
import { arrayMove as j, SortableContext as u, sortableKeyboardCoordinates as I } from "../../../../node_modules/@dnd-kit/sortable/dist/sortable.esm.js";
import { SortableItem as g, DragHandler as h } from "./helper.js";
function d({ items: r, onChange: i, renderItem: s }) {
  const l = f(
    a(b),
    a(S, {
      coordinateGetter: I
    })
  );
  return /* @__PURE__ */ e.jsx(
    p,
    {
      sensors: l,
      onDragEnd: ({ active: n, over: o }) => {
        if (o && n.id !== (o == null ? void 0 : o.id)) {
          const x = r.findIndex(({ id: t }) => t === n.id), c = r.findIndex(({ id: t }) => t === o.id);
          i(j(r, x, c));
        }
      },
      children: /* @__PURE__ */ e.jsx(u, { items: r, children: /* @__PURE__ */ e.jsx(
        "div",
        {
          className: "SortableList",
          role: "application",
          children: r.map((n) => /* @__PURE__ */ e.jsx(m.Fragment, { children: s(n) }, n.id))
        }
      ) })
    }
  );
}
d.Item = g;
d.DragHandler = h;
export {
  d as SortableList
};
//# sourceMappingURL=SortableList.js.map
